var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('section',{staticClass:"view-ui-state-dots"},_vm._l((_vm.amount),function(i){return _c('div',{key:i,staticClass:"dot",class:{ active: i - 1 === _vm.activeIndex }})}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }